import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceListings from "./sections/ServiceListings";
import WhyChooseAPlusFire from "./sections/WhyChooseAPlusFire";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceListings />
      <WhyChooseAPlusFire />
      <Footer />
    </div>;
}